<template>
  <div>
    <croppa
      v-model="croppa"
      v-bind="$attrs"
      @file-choose="onFileChoose"
      @file-type-mismatch="onFileTypeMismatch"
      @file-size-exceed="onFileSizeExceed"
      @new-image="onImageDrawn"
      @initial-image-loaded="onImageDrawn"
      @image-remove="onImageRemove"
      @draw="processImage"
    />
    <div
      v-if="localError"
      class="caption error--text mt-2"
    >
      {{ localError }}
    </div>
  </div>
</template>

<script>
import 'vue-croppa/dist/vue-croppa.min.css'

export default {
  name: 'ImageCrop',
  props: {
    value: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      croppa: {},
      localError: ''
    }
  },
  watch: {
    value: function (val) {
      if (val === null) this.refresh()
    }
  },
  methods: {
    onFileChoose() {
      this.localError = ''
      this.$emit('errors', [])
      this.$emit('file-choose')
    },
    onFileTypeMismatch() {
      this.localError = 'Only JPEG and PNG images are allowed.'
      // this.$emit('errors', ['Only JPEG and PNG images are allowed.'])
    },
    onFileSizeExceed() {
      this.localError = 'File size is too large. Maximum 2MB is allowed.'
      // this.$emit('errors', ['File size is too large. Maximum 2MB is allowed.'])
    },
    onImageDrawn() {
      this.$nextTick(() => {
        this.processImage()
      })
    },
    onImageRemove() {
      this.$emit('errors', [])
      this.$emit('input', undefined)
      this.localError = ''
      this.$emit('file-remove')
    },
    processImage() {
      this.$nextTick(() => {
        this.$emit('input', this.croppa.generateDataUrl('image/jpeg', 0.8))
      })
    },
    refresh() {
      this.croppa.refresh()
    }
  }
}
</script>

<style>
.croppa-container svg.icon-remove {
  z-index: 1 !important;
}
.croppa-container canvas {
  margin-bottom: -10px;
  border-radius: 10px;
}
.croppa-container {
  border-radius: 10px;
  border: 1px dashed rgba(0, 0, 0, 0.2);
}
</style>
